import { render } from "./UnsubmittedPrs.vue?vue&type=template&id=c2e1dee8"
import script from "./UnsubmittedPrs.vue?vue&type=script&lang=js"
export * from "./UnsubmittedPrs.vue?vue&type=script&lang=js"

import "./UnsubmittedPrs.vue?vue&type=style&index=0&id=c2e1dee8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__